import AiSearch from "./icons/AiSearch.js";
import Car from "./icons/Car.js";
import CarOutline from "./icons/CarOutline.js";
import CouchFill from "./icons/CouchFill.js";
import Cruise from "./icons/Cruise.js";
import CruiseOutline from "./icons/CruiseOutline.js";
import Discount from "./icons/Discount.js";
import DiscountFill from "./icons/DiscountFill.js";
import Disney from "./icons/Disney.js";
import Facebook from "./icons/Facebook.js";
import Flight from "./icons/Flight.js";
import FlightOutline from "./icons/FlightOutline.js";
import GitHub from "./icons/GitHub.js";
import Hotel from "./icons/Hotel.js";
import HotelOutline from "./icons/HotelOutline.js";
import Instagram from "./icons/Instagram.js";
import LateNight from "./icons/LateNight.js";
import LateNightWhite from "./icons/LateNightWhite.js";
import Package from "./icons/Package.js";
import PackageOutline from "./icons/PackageOutline.js";
import Penny from "./icons/Penny.js";
import Pinterest from "./icons/Pinterest.js";
import PricelineP from "./icons/PricelineP.js";
import Refund from "./icons/Refund.js";
import Sparkle from "./icons/Sparkle.js";
import TikTok from "./icons/TikTok.js";
import TripInterruption from "./icons/TripInterruption.js";
import Waveform from "./icons/Waveform.js";
import WhatsApp from "./icons/WhatsApp.js";
import XTwitter from "./icons/XTwitter.js";
import YouTube from "./icons/YouTube.js";
const iconRegistry = {
    AiSearch: AiSearch,
    Car: Car,
    CarOutline: CarOutline,
    CouchFill: CouchFill,
    Cruise: Cruise,
    CruiseOutline: CruiseOutline,
    Discount: Discount,
    DiscountFill: DiscountFill,
    Disney: Disney,
    Facebook: Facebook,
    Flight: Flight,
    FlightOutline: FlightOutline,
    GitHub: GitHub,
    Hotel: Hotel,
    HotelOutline: HotelOutline,
    Instagram: Instagram,
    LateNight: LateNight,
    LateNightWhite: LateNightWhite,
    Package: Package,
    PackageOutline: PackageOutline,
    Penny: Penny,
    Pinterest: Pinterest,
    PricelineP: PricelineP,
    Refund: Refund,
    Sparkle: Sparkle,
    TikTok: TikTok,
    TripInterruption: TripInterruption,
    Waveform: Waveform,
    WhatsApp: WhatsApp,
    XTwitter: XTwitter,
    YouTube: YouTube
};
export { iconRegistry };
